@if (fieldSet().includes(field())) {
  <div class="row mb-3">
    <div class="col-12 col-md-6">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6 col-md-4 mb-1">
          <label [for]="field() + '.question'">{{
            config().title.question
          }}</label>
        </div>
        <div class="col-12 col-sm-6 col-md-8">
          <div class="form-check form-check-inline form-check-lg">
            <input
              class="form-check-input me-2"
              type="radio"
              [formControlName]="answerProperty"
              [id]="field() + '.question' + 'Yes'"
              [attr.data-cy]="field() + '-radio-yes'"
              [value]="true"
            />
            <label
              class="form-check-label"
              [for]="field() + '.question' + 'Yes'"
            >
              {{ 'common.yes' | translate }}
            </label>
          </div>
          <div class="form-check form-check-inline form-check-lg">
            <input
              class="form-check-input me-2"
              type="radio"
              [formControlName]="answerProperty"
              [id]="field() + '.question' + 'No'"
              [attr.data-cy]="field() + '-radio-no'"
              [value]="false"
            />
            <label
              class="form-check-label"
              [for]="field() + '.question' + 'No'"
            >
              {{ 'common.no' | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-8">
          <app-validation-error
            [for]="answerProperty"
            [translations]="
              config().validationTranslation?.answer || 'validation.generic'
            "
            [attr.data-cy]="field() + '-validation-error'"
          ></app-validation-error>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 align-self-center mt-3 mt-md-0">
      @if (
        config().type === RadioFormType.Double && form.get(answerProperty).value
      ) {
        <div class="row align-items-center">
          <div class="col-12 col-sm-6 col-md-4 mb-1">
            <label [for]="field() + '.subQuestion'">{{
              config().title.subQuestion
            }}</label>
          </div>
          <div class="col-12 col-sm-6 col-md-8">
            <div class="form-check form-check-inline form-check-lg">
              <input
                class="form-check-input me-2"
                type="radio"
                [formControlName]="subAnswerProperty"
                [id]="field() + '.subQuestion' + 'Yes'"
                [attr.data-cy]="field() + '-sub-radio-yes'"
                [value]="subAnswerYesValue"
              />
              <label
                class="form-check-label"
                [for]="field() + '.subQuestion' + 'Yes'"
              >
                {{ 'common.yes' | translate }}
              </label>
            </div>
            <div class="form-check form-check-inline form-check-lg">
              <input
                class="form-check-input me-2"
                type="radio"
                [formControlName]="subAnswerProperty"
                [id]="field() + '.subQuestion' + 'No'"
                [attr.data-cy]="field() + '-sub-radio-no'"
                [value]="subAnswerNoValue"
              />
              <label
                class="form-check-label"
                [for]="field() + '.subQuestion' + 'No'"
              >
                {{ 'common.no' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-6 col-md-8">
            <app-validation-error
              [for]="subAnswerProperty"
              [translations]="
                config().validationTranslation?.subAnswer ||
                'validation.generic'
              "
              [attr.data-cy]="field() + '-sub-validation-error'"
            />
          </div>
        </div>
      }
    </div>
  </div>
}
